document.addEventListener("DOMContentLoaded", function() {
  
    const button = document.querySelector('.js-toggle-menu');
    const closeIcon = document.querySelector('.toggle-menu__close');
    const burgerIcon = document.querySelector('.toggle-menu__burger');
    const menu = document.querySelector('.navigation-mobile');

    if (button) {
        button.addEventListener('click', (e) => {
            // toggle icons.
            // set body to have menu active
            closeIcon.classList.toggle('u-hidden');
            burgerIcon.classList.toggle('u-hidden');
            menu.classList.toggle('is-visible');
            document.body.classList.toggle('has-mobile-menu-active');
    
        });
    }


});
